import React from 'react';
import { Order } from 'src/components/Table/types';

export enum Columns {
  name = 'associateSchoolNumber',
  centerNumber = 'name',
  status = 'status',
  link = 'link',
}

export type Row = {
  cells: {
    [Columns.centerNumber]: React.ReactElement;
    [Columns.name]: React.ReactElement;
    [Columns.status]: React.ReactElement;
  };
  link: string;
};

export type HeadCell = {
  id: Columns;
  label: string;
  order: Order;
};
